import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  paper:{
    width: '40%',
  },
  button:{
    width: 100,
    marginLeft:10,
    marginTop:10,
    boxShadow: '0 0 0 0rem #FFF',
  }
}));
